import { styled as i, Box as d, Typography as h, useMediaQuery as y } from "@mui/material";
import { useCurrencyContext as k } from "../../currency-lib/contexts/CurrencyContext.js";
import b from "../../temp-lib/styles/theme.js";
import { noForwardProps as T, noForwardCustomProps as C } from "../../temp-lib/util/styled/index.js";
import x from "./Token.js";
import * as s from "ramda";
import { useMemo as w } from "react";
import { jsxs as N, jsx as r } from "react/jsx-runtime";
const M = i(d, T)`
  background: var(--inventory-buttons, #31333f);
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 175px;
  padding: 10px 20px;

  ${(n) => n.__displayOne && "align-items: center;"}
`, B = i(h, C(["color"]))`
  color: ${(n) => n.color || "white"};
  font-weight: 700;
`, _ = i(d)`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;

  .Custom-Token:last-child {
    border-right: unset;
    padding-right: unset;
  }
`, j = i(d)`
  border-right: 1px solid #7d7e7f;
  padding-right: 16px;
`, A = i(x)`
  max-width: 120px;
`, u = (n) => {
  const {
    onChain: l,
    token: o
  } = n, {
    getApeironPrice: t,
    getCurrency: a
  } = k(), p = y(b.breakpoints.down("res1280")) ? A : x, e = a(o.type), m = s.isNil(e) || l && !(e.decimals > 0) && o.amount !== "0";
  return /* @__PURE__ */ r(j, {
    className: "Custom-Token",
    children: /* @__PURE__ */ r(p, {
      amount: t(o.type, o.amount, {
        maxDecimal: 4,
        maxLength: 6
      }),
      iconUrl: o.image,
      loading: m,
      unit: o.name
    })
  }, o.name);
}, L = (n) => {
  const {
    className: l,
    title: o,
    tokens: t,
    displayOne: a = !1,
    onChain: c = !1
  } = n, p = w(() => s.reduce((e, m) => {
    const f = m.amount || "0", g = e.amount || "0";
    return Number(f) > Number(g) ? m : e;
  }, s.head(t), t), [t]);
  return s.isNotEmpty(t) ? /* @__PURE__ */ N(M, {
    __displayOne: a,
    className: l,
    children: [/* @__PURE__ */ r(B, {
      className: "Custom-Title",
      children: o
    }), /* @__PURE__ */ r(_, {
      className: "Custom-Token-Box",
      children: a ? /* @__PURE__ */ r(u, {
        onChain: c,
        token: p
      }) : s.map((e) => /* @__PURE__ */ r(u, {
        onChain: c,
        token: e
      }, e.name), t)
    })]
  }) : null;
};
export {
  L as default
};
//# sourceMappingURL=TokenSection.js.map
